/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Nav_Audit1Inputs */

const en_coinvestments_nav_audit1 = /** @type {(inputs: Coinvestments_Nav_Audit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Audit`)
};

/**
* | output |
* | --- |
* | "Audit" |
*
* @param {Coinvestments_Nav_Audit1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_nav_audit1 = /** @type {((inputs?: Coinvestments_Nav_Audit1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Nav_Audit1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_nav_audit1(inputs)
});
export { coinvestments_nav_audit1 as "coInvestments_nav_audit" }